import React from 'react'
import "./color.css"

function WhiteHC() {
    var x = localStorage.getItem("percentage hc")
    return (
        <div className = "init__background">
            {x == "NaN" ? "null": x} 
        </div>
    )
}

export default WhiteHC
